export function name(state) {
  return state.name;
}

export function role(state) {
  return state.role;
}

export function login(state) {
  return state.login;
}

export function fullName(state) {
  return state.fullName;
}

export function id(state) {
  return state.id;
}
